import WikiEntity from '../entities/Wiki';

export type State = WikiEntity[];

const initialState: State = [];

const Wiki = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_WIKIS_BY_GROUP':
      return [...state, ...action.wikis].filter(
        (wiki, index, self) => self.map(w => w.id).indexOf(wiki.id) === index
      );

    case 'SUCCESS_READ_WIKIS_DIFF':
      const wikisChanged = state.map(wiki =>
        action.wikis.map((m: WikiEntity) => m.id).includes(wiki.id)
          ? action.wikis.find((m: WikiEntity) => m.id === wiki.id)
          : wiki
      );

      const wikisToAdd = action.wikis.filter(
        (wiki: WikiEntity) => !state.map(m => m.id).includes(wiki.id)
      );

      return [...wikisChanged, ...wikisToAdd];

    case 'SUCCESS_CREATE_WIKI':
      return [...state, action.wiki].filter(
        (wiki, index, self) => self.map(w => w.id).indexOf(wiki.id) === index
      );

    case 'SUCCESS_UPDATE_WIKI':
      return state.map(wiki => {
        return wiki.id === action.wiki.id ? action.wiki : wiki;
      });

    case 'SUCCESS_DESTROY_WIKI':
      return state.filter(wiki => wiki.id !== action.wiki.id);
  }

  return state;
};

export default Wiki;



// WEBPACK FOOTER //
// ./src/reducers/Wiki.ts